import { render, staticRenderFns } from "./storage-box.vue?vue&type=template&id=518d86c1&scoped=true&"
import script from "./storage-box.vue?vue&type=script&lang=js&"
export * from "./storage-box.vue?vue&type=script&lang=js&"
import style0 from "./storage-box.vue?vue&type=style&index=0&id=518d86c1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518d86c1",
  null
  
)

export default component.exports